var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReceiverBusiness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.277 4.531c-.27 0-.492.235-.492.521v1.563c0 .286.222.52.492.52h1.476c.27 0 .492-.234.492-.52V5.052c0-.286-.221-.52-.492-.52H7.277Zm5.413 0h-1.476c-.271 0-.492.235-.492.521v1.563c0 .286.22.52.492.52h1.476c.27 0 .492-.234.492-.52V5.052c0-.286-.222-.52-.492-.52ZM7.277 8.698c-.27 0-.492.234-.492.52v1.563c0 .287.222.521.492.521h1.476c.27 0 .492-.234.492-.52V9.218c0-.287-.221-.521-.492-.521H7.277Zm5.413 0h-1.476c-.271 0-.492.234-.492.52v1.563c0 .287.22.521.492.521h1.476c.27 0 .492-.234.492-.52V9.218c0-.287-.222-.521-.492-.521Z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.079 16.667V3.75c0-1.15.883-2.083 1.968-2.083h7.873c1.085 0 1.968.934 1.968 2.083v12.917h.822c.436 0 .79.373.79.833 0 .46-.354.833-.79.833H3.29c-.437 0-.79-.373-.79-.833 0-.46.353-.833.79-.833h.789ZM5.555 3.75c0-.286.221-.52.492-.52h7.873c.27 0 .492.234.492.52v12.917h-2.953v-1.98c0-.862-.66-1.562-1.476-1.562-.815 0-1.476.7-1.476 1.563v1.979H5.555V3.75Z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiverBusiness);
export default __webpack_public_path__ + "static/media/receiver_business.d11ce90b4cb45b4e5bfa4ffd2341283f.svg";
export { ForwardRef as ReactComponent };